import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "top-bar-menu" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconDotsHorizontal = _resolveComponent("IconDotsHorizontal")
  const _component_NcIconSvgWrapper = _resolveComponent("NcIconSvgWrapper")
  const _component_NcActionButton = _resolveComponent("NcActionButton")
  const _component_NcLoadingIcon = _resolveComponent("NcLoadingIcon")
  const _component_IconStop = _resolveComponent("IconStop")
  const _component_NcActionSeparator = _resolveComponent("NcActionSeparator")
  const _component_IconFileOutline = _resolveComponent("IconFileOutline")
  const _component_NcActionLink = _resolveComponent("NcActionLink")
  const _component_IconVideoOutline = _resolveComponent("IconVideoOutline")
  const _component_IconDotsCircle = _resolveComponent("IconDotsCircle")
  const _component_IconFullscreen = _resolveComponent("IconFullscreen")
  const _component_IconFullscreenExit = _resolveComponent("IconFullscreenExit")
  const _component_IconCogOutline = _resolveComponent("IconCogOutline")
  const _component_NcActions = _resolveComponent("NcActions")
  const _component_NcButton = _resolveComponent("NcButton")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$props.isSidebar)
      ? (_openBlock(), _createBlock(_component_NcActions, {
          key: 0,
          "force-menu": "",
          title: $options.t('spreed', 'Conversation actions'),
          "aria-label": $options.t('spreed', 'Conversation actions'),
          variant: "tertiary"
        }, _createSlots({
          default: _withCtx(() => [
            ($setup.isInCall && $options.canFullModerate)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (!$options.isOneToOneConversation)
                    ? (_openBlock(), _createBlock(_component_NcActionButton, {
                        key: 0,
                        "close-after-click": "",
                        onClick: $options.forceMuteOthers
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_NcIconSvgWrapper, {
                            svg: $setup.IconMicrophoneOffOutline,
                            size: 20
                          }, null, 8, ["svg"])
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Mute others')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  ($options.canModerateRecording)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (!$options.isRecording && !$options.isStartingRecording && $setup.isInCall)
                          ? (_openBlock(), _createBlock(_component_NcActionButton, {
                              key: 0,
                              "close-after-click": "",
                              onClick: $options.startRecording
                            }, {
                              icon: _withCtx(() => [
                                _createVNode(_component_NcIconSvgWrapper, {
                                  svg: $setup.IconScreenRecordOutline,
                                  size: 20
                                }, null, 8, ["svg"])
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Start recording')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : ($options.isStartingRecording && $setup.isInCall)
                            ? (_openBlock(), _createBlock(_component_NcActionButton, {
                                key: 1,
                                "close-after-click": "",
                                onClick: $options.stopRecording
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_NcLoadingIcon, { size: 20 })
                                ]),
                                default: _withCtx(() => [
                                  _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Cancel recording start')), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"]))
                            : ($options.isRecording && $setup.isInCall)
                              ? (_openBlock(), _createBlock(_component_NcActionButton, {
                                  key: 2,
                                  "close-after-click": "",
                                  onClick: $options.stopRecording
                                }, {
                                  icon: _withCtx(() => [
                                    _createVNode(_component_IconStop, { size: 20 })
                                  ]),
                                  default: _withCtx(() => [
                                    _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Stop recording')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (!$options.isOneToOneConversation || $options.canModerateRecording)
                    ? (_openBlock(), _createBlock(_component_NcActionSeparator, { key: 2 }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            ($options.isFileConversation)
              ? (_openBlock(), _createBlock(_component_NcActionLink, {
                  key: 1,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  href: $options.linkToFile
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_IconFileOutline, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Go to file')), 1)
                  ]),
                  _: 1
                }, 8, ["href"]))
              : _createCommentVNode("", true),
            ($setup.isInCall)
              ? (_openBlock(), _createBlock(_component_NcActionButton, {
                  key: 2,
                  "close-after-click": "",
                  onClick: $options.showMediaSettingsDialog
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_IconVideoOutline, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Check devices')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            ($options.canConfigureBreakoutRooms)
              ? (_openBlock(), _createBlock(_component_NcActionButton, {
                  key: 3,
                  "close-after-click": "",
                  onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('openBreakoutRoomsEditor')))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_IconDotsCircle, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Set up breakout rooms')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ($setup.isInCall && $options.canDownloadCallParticipants)
              ? (_openBlock(), _createBlock(_component_NcActionLink, {
                  key: 4,
                  href: $options.downloadCallParticipantsLink,
                  target: "_blank"
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_NcIconSvgWrapper, {
                      svg: $setup.IconFileDownload,
                      size: 20
                    }, null, 8, ["svg"])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Download attendance list')), 1)
                  ]),
                  _: 1
                }, 8, ["href"]))
              : _createCommentVNode("", true),
            (!$setup.isInCall)
              ? (_openBlock(), _createBlock(_component_NcActionButton, {
                  key: 5,
                  "aria-label": $options.t('spreed', 'Toggle full screen'),
                  "close-after-click": "",
                  onClick: $setup.toggleFullscreen
                }, {
                  icon: _withCtx(() => [
                    (!$setup.isFullscreen)
                      ? (_openBlock(), _createBlock(_component_IconFullscreen, {
                          key: 0,
                          size: 20
                        }))
                      : (_openBlock(), _createBlock(_component_IconFullscreenExit, {
                          key: 1,
                          size: 20
                        }))
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString($options.labelFullscreen), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label", "onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_NcActionButton, {
              "close-after-click": "",
              onClick: $options.openConversationSettings
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_IconCogOutline, { size: 20 })
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Conversation settings')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 2
        }, [
          ($setup.isInCall)
            ? {
                name: "icon",
                fn: _withCtx(() => [
                  _createVNode(_component_IconDotsHorizontal, { size: 20 })
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["title", "aria-label"]))
      : (_openBlock(), _createBlock(_component_NcButton, {
          key: 1,
          class: "top-bar__icon-wrapper",
          "aria-label": $options.t('spreed', 'Check devices'),
          title: $options.t('spreed', 'Check devices'),
          variant: "tertiary",
          onClick: $options.showMediaSettingsDialog
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_IconCogOutline, { size: 20 })
          ]),
          _: 1
        }, 8, ["aria-label", "title", "onClick"]))
  ]))
}